import { useRef } from 'react'

export const useVideoAdTracking = ({
  advert,
  onRequestCloseAdvert,
  onProgress: onProgressCb,
  notifyError,
}) => {
  const trackEvent = (event) => {
    const url = advert.trackingEvents[event]
    url && fetch(url).catch(notifyError)
  }

  const reportedProgressRef = useRef({})

  return {
    onProgress: (playedSeconds) => {
      onProgressCb?.(playedSeconds)

      const reportedProgress = reportedProgressRef.current
      const progress = playedSeconds / advert.mediaFile.duration

      if (progress >= 0.25 && !reportedProgress.firstQuartile) {
        trackEvent('firstQuartile')
        reportedProgress.firstQuartile = true
      }
      if (progress >= 0.5 && !reportedProgress.midpoint) {
        trackEvent('midpoint')
        reportedProgress.midpoint = true
      }
      if (progress >= 0.75 && !reportedProgress.thirdQuartile) {
        trackEvent('thirdQuartile')
        reportedProgress.thirdQuartile = true
      }
    },

    onError: (error) => {
      onRequestCloseAdvert()
      advert.errorUrl && fetch(advert.errorUrl).catch(notifyError)
      notifyError(error)
    },

    onEnd: () => {
      onRequestCloseAdvert()
      trackEvent('complete')
    },

    onSkip: () => {
      onRequestCloseAdvert()
      trackEvent('skip')
    },

    onStart: () => trackEvent('start'),
    onPaused: () => trackEvent('pause'),
    onPlayed: () => trackEvent('resume'),
    onMuteToggle: (muted) => (muted ? trackEvent('mute') : trackEvent('unmute')),
  }
}
